import { getString } from '@vrw/data'
import { useFlightsSearchParams } from './useFlightsSearchParams'

export const useSearchSummaryTexts = ({ short = false } = {}) => {
  const formData = useFlightsSearchParams()

  const destinationCitiesText = getString(`redSkySearch.results.search.summary.route${short ? '.short' : ''}`)
    .replace('{{from}}', formData?.departure?.cityName ?? '')
    .replace('{{to}}', formData?.destination?.cityName ?? '')

  const destinationCodesText = getString('redSkySearch.results.search.summary.route')
    .replace('{{from}}', formData?.departure?.code ?? '')
    .replace('{{to}}', formData?.destination?.code ?? '')

  const passengersText = Object.entries({
    adults: formData?.adults,
    youngAdults: formData?.youngAdults,
    children: formData?.children,
    infant: formData?.infant,
  })
    .filter(([, count]) => count! > 0)
    .map(([type, count]) => {
      const key = `redSkySearch.results.search.summary.${type}.${count! > 1 ? 'other' : 'one'}`
      return getString(key).replace('{{count}}', `${count}`)
    })
    .join(', ')

  return {
    destinationCitiesText,
    destinationCodesText,
    passengersText,
  }
}
